import { useQueryClient, useMutation } from 'react-query';
import { SapFlowViewConfig, ViewConfigUpdateDTO, ViewLayer, ViewLayerParam } from '../../types';
import { useAxiosInstance } from '../common';

const endpoint = 'viewer_config';

interface ViewLayerUpdateDTO {
    viewerId: string;
    params: ViewLayerParam[];
}

const useViewerConfigParamsUpdate = () => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (params: ViewLayerUpdateDTO) => {
      const response = await axios.put<SapFlowViewConfig>(endpoint + "/" + params.viewerId + "/params", params.params);
      return response.data;
    },
    {
      onSuccess: (data: any, variables: ViewLayerUpdateDTO) => {
        queryClient.invalidateQueries(['viewerConfig', variables.viewerId], { refetchInactive: true });
      },
    }
  );
};

export default useViewerConfigParamsUpdate;
